import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { overview } from "@/data/destinations/overview";
import { CountryHero } from "@/components/destinations/CountryHero";
import { EducationSection } from "@/components/destinations/EducationSection";
import { CareerSection } from "@/components/destinations/CareerSection";
import { UniversitySection } from "@/components/destinations/UniversitySection";
import { VisaSection } from "@/components/destinations/VisaSection";
import { GuideClosing } from "@/components/destinations/GuideClosing";
import "@/country-guides.css";

const SECTIONS = [["education", "Education"], ["careers", "Careers & salaries"], ["universities", "Universities"], ["visa", "Visa & documents"]];

function CountryContent({ country, slug }) {
  const [level, setLevel] = useState("undergraduate");
  const { hash } = useLocation();
  useEffect(() => {
    const target = hash ? document.getElementById(hash.slice(1)) : null;
    if (target) target.scrollIntoView({ behavior: "instant", block: "start" });
    else window.scrollTo({ top: 0, behavior: "instant" });
  }, [slug, hash]);
  useEffect(() => {
    const previousTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.content;
    document.title = `Study in ${country.name} | Courses, Careers & Visa Guide — EDUBRIDGE`;
    if (meta) meta.content = `Explore undergraduate and postgraduate study in ${country.name}: career salary ranges, top universities, student visa rules and required documents.`;
    return () => { document.title = previousTitle; if (meta) meta.content = previousDescription; };
  }, [country]);
  return (
    <div className="country-guide min-h-screen bg-ink text-frost" style={{ "--guide-accent": country.accent }} data-testid={`country-guide-${slug}`}>
      <Nav />
      <main>
        <CountryHero country={country} slug={slug} level={level} />
        <nav className="guide-section-nav" aria-label="Country guide sections" data-testid="guide-section-nav"><div className="container-x">{SECTIONS.map(([id, label], index) => <a key={id} href={`#${id}`} data-testid={`guide-section-link-${id}`}><span className="font-mono text-xs opacity-50">0{index + 1}</span>{label}</a>)}</div></nav>
        <EducationSection country={country} level={level} setLevel={setLevel} />
        <CareerSection slug={slug} level={level} />
        <UniversitySection slug={slug} />
        <VisaSection slug={slug} />
        <GuideClosing country={country} slug={slug} level={level} />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default function CountryGuide() {
  const { slug } = useParams();
  const country = Object.hasOwn(overview, slug) ? overview[slug] : null;
  if (!country) return <div className="flex min-h-screen items-center justify-center bg-ink p-6 text-frost"><main data-testid="country-not-found" className="max-w-xl"><h1 className="font-display text-4xl">This destination isn’t in our guide.</h1><Link to="/#destinations" data-testid="country-not-found-back" className="mt-6 inline-block text-mint underline">Explore our six destinations</Link></main></div>;
  return <CountryContent key={slug} country={country} slug={slug} />;
}